<script>
export default {
  name: "AtiCarrier"
}
</script>


<template>
  <div class="tab-content bg-light">
    <div class="tab-pane active " id="left-user" role="tabpanel" aria-labelledby="left-user-tab">
      <h1>База перевозчиков ATI</h1>
      <div ref="xspreadsheet" id="xapp"></div>
    </div>
  </div>
</template>

<script setup>
import x_spreadsheet from "x-data-spreadsheet-wertolet/src/index.js";
import { ref, onMounted } from "vue";
import {getCarriers} from "@/API/ways/carrier";

// const xspreadsheet = ref(null);

const options = {
  // mode: 'read',
  style: {
    bgcolor: '#ffffff',        // цвет фона для всех ячеек
    align: 'left',           // выравнивание текста по центру
    valign: 'bottom',          // вертикальное выравнивание по центру
    textwrap: false,            // перенос текста в ячейке
    underline: false,          // подчеркнутый текст
    color: '#333',             // цвет текста
    font: {
      name: 'Arial',
      size: 11,
      bold: false,
      italic: false,
    }
  },
  view: {
    height: () => document.documentElement.clientHeight - 35,
  },
  col: { len: 15 }
};
const firstRow = {
  cells: {
    0: {text: 'Дата', style: 0},
    1: {text: 'Название компании', style: 0},
    2: {text: 'Код организации', style: 0},
    3: {text: 'Имя перевозчика', style: 0},
    4: {text: 'Базовый город', style: 0},
    5: {text: 'Город загрузки', style: 0},
    6: {text: 'Город выгрузки', style: 0},
    7: {text: 'Все города(где когда-либо грузились)', style: 0},
    8: {text: 'Номер телефона(СТРОГО ФОРМАТ:889113432424)', style: 0},
    9: {text: 'Тип транспорта', style: 0},
    10: {text: 'Грузоподъемность, т', style: 0},
    11: {text: 'Кубатура, м3', style: 0},
    12: {text: 'ADR (Класс опасности)', style: 0},
    13: {text: 'Международник?', style: 0},
    14: {text: 'Комментарий перевозчика', style: 0}
  },
  height: 100,
  mode: 'read'
};
const firstRowStyle = {
  bgcolor: '#10ff00',
  textwrap: true,
  color: '#000000',
  border: {
    top: ['thin', '#000000'],
    bottom: ['thin', '#000000'],
    right: ['thin', '#000000'],
    left: ['thin', '#000000'],
  },
  font: {
    name: 'Arial',
    size: 11,
    bold: true,
    italic: false,
  }
};

let rows = {0: firstRow};
let tableCarrier = ref({})

onMounted(async () => {
  await getCarriers().then((response) => {
    console.log(response.data.data);
    tableCarrier.value = response.data.data;
    rows.len = tableCarrier.value.length + 100;
    console.log(rows);
    console.log(rows.len);
    console.log(tableCarrier.value.length);
    for (let i = 0; i < tableCarrier.value.length; i++) {
      rows[i + 1] = {
        cells: {
          0: {text: tableCarrier.value[i].datetime},
          1: {text: tableCarrier.value[i].name_organization},
          2: {text: tableCarrier.value[i].code_organization},
          3: {text: tableCarrier.value[i].name_carrier},
          4: {text: tableCarrier.value[i].base_city},
          5: {text: tableCarrier.value[i].load_city},
          6: {text: tableCarrier.value[i].unload_city},
          7: {text: tableCarrier.value[i].all_cities},
          8: {text: tableCarrier.value[i].phone_number},
          9: {text: tableCarrier.value[i].type_transport},
          10: {text: tableCarrier.value[i].load_capacity},
          11: {text: tableCarrier.value[i].volume},
          12: {text: tableCarrier.value[i].adr},
          13: {text: tableCarrier.value[i].international},
          14: {text: tableCarrier.value[i].comment}
        }
      }
    }
  });
  const s = new x_spreadsheet('#xapp', options)
      .loadData([{
        name: 'Автоцисцерна',
        freeze: 'A2',
        styles: [
          firstRowStyle
        ], rows
      },
        // {
        //   name: 'Все закрытые',
        //   freeze: 'A2',
        //   styles: [
        //     firstRowStyle
        //   ], rows}
      ])
      .change(data => {
        // TODO
      });
})
</script>

<style scoped>

</style>